import { createFileRoute } from '@tanstack/react-router'

import { ScorecardScreen } from './-components/scorecard-screen.tsx'

export const Route = createFileRoute('/business-performance/client-scorecard')({
  component: ScorecardScreen
})
